import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as eventActions from '../../../../store/actions/events';
import AwardsTable from './AwardsTable';

class AwardsReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dancerNumber: '',
      loading: false,
      error: '',
      data: null
    };
  }

  handleChange = (e) => {
    this.setState({ dancerNumber: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { dancerNumber } = this.state;
    const { auth, match } = this.props;

    const dn = Number(dancerNumber);
    if (!dn || dn < 0) {
      this.setState({ error: 'Please enter a valid dancer number.' });
      return;
    }

    this.setState({ loading: true, error: '', data: null });

    const eventId = match?.params?.id;
    const token = this.props.auth.token._id;

    this.props.getAwardsByDancer(
      eventId,
      dn,
      token,
      (responseData) => {
        this.setState({ data: responseData, loading: false, error: '' });
      },
      (err) => {
        const message =
          (err && (err.message || err.error || err.toString())) ||
          'Unable to fetch awards. Please try again.';
        this.setState({ error: message, loading: false, data: null });
      }
    );
  };

  render() {
    const { dancerNumber, loading, error, data } = this.state;

    return (

      <div className={'page-container elevated rounded ex-pad'}>
        <h4 className="mb-3">Awards Report</h4>

        <form onSubmit={this.handleSubmit} className="mb-3">
          <div className="form-group">
            <label htmlFor="dancerNumber">Dancer Number</label>
            <input
              id="dancerNumber"
              name="dancerNumber"
              type="number"
              className="form-control"
              style={{ width: '300px' }}
              value={dancerNumber}
              onChange={this.handleChange}
              min="0"
              placeholder="Enter dancer number"
              required
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary mt-2"
            disabled={loading}
          >
            {loading ? 'Loading…' : 'Submit'}
          </button>
        </form>

        {error ? (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        ) : null}

        {data ? <AwardsTable data={data} /> : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

const mapDispatchToProps = (dispatch) => ({
  getAwardsByDancer: (eventId, dancerNumber, token, onSuccess, onError) => {
    dispatch(
      eventActions.getAwardsByDancer(eventId, dancerNumber, token, onSuccess, onError)
    );
  }
});

const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(AwardsReport));

class AwardsReportContainer extends React.Component {
  render() {
    return (
      <div>
        <Connected {...this.props} />
      </div>
    );
  }
}

export default AwardsReportContainer;
